// extracted by mini-css-extract-plugin
export default {"statusHeader":"OrgsOrdersTableTHead_statusHeader__1uGJ5","placeHolderShimmer":"OrgsOrdersTableTHead_placeHolderShimmer__tkiVj"};